export interface CreateAnnotationDto {
    content: string;
    taskName: string;
    workflowArea?: string;
    mentions?: string[];
}
